import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login/index";
import register from "@/components/login/register";
import forgetPwd from "@/components/login/forgetPwd";

Vue.use(Router);
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: "/", //登录页面 admin 平台 merchant 商户 distributor 经销商
      redirect: "/login/admin"
    },
    {
      path: "/login/:type", //登录页面 admin 平台 merchant 商户 distributor 经销商
      name: "login",
      component: login
    },
    {
      path: "/register", //登录页面 admin 平台 merchant 商户 distributor 经销商
      name: "register",
      component:  register
    },
    {
      path: "/forgetPwd", //登录页面 admin 平台 merchant 商户 distributor 经销商
      name: "forgetPwd",
      component:  forgetPwd
    },
    // 经销商 ---------------------------------------------------------------
    {
      path: "/agent",
      name: "agent",
      component: () => import("../components/agent/index"),
      children: [
        {
          path: "/agent/info",
          name: "info",
          component: () =>
            import("../components/agent/info/info")
        }, //经销商=>个人信息管理=>个人信息
        {
          path: "/agent/authCode",
          name: "authCode",
          component: () =>
            import("../components/agent/authCode/authCode")
        }, //经销商=>个人信息管理=>授权码

        {
          path: "/agent/merchant",
          name: "merchant",
          component: () =>
            import("../components/agent/merchant/merchant")
        }, //经销商=>商户管理=>商户管理
        // {
        //   path: "/agent/shopManage",
        //   name: "shopManage",
        //   component: () =>
        //     import("../components/agent/merchant/shopManage")
        // }, //经销商=>商户管理=>店铺管理
        {
          path: "/agent/bill",
          name: "bill",
          component: () =>
            import("../components/agent/merchant/bill")
        }, //经销商=>商户管理=>报表
        {
          path: "/agent/shopReport",
          name: "shopReport",
          component: () =>
            import("../components/agent/merchant/shopReport")
        }, //经销商=>商户管理=>报表导出
        {
          path: "/agent/exportUserMoney",
          name: "exportUserMoney",
          component: () =>
            import("../components/agent/merchant/exportUserMoney")
        }, //经销商=>商户管理=>报表导出
        {
          path: "/agent/deviceUnbind",
          name: "deviceUnbind",
          component: () =>
            import("../components/agent/device/deviceUnbind")
        }, //经销商=>设备管理=>设备解绑
        {
          path: "/agent/deviceQuickUnbind",
          name: "deviceQuickUnbind",
          component: () =>
            import("../components/agent/device/deviceQuickUnbind")
        }, //经销商=>设备管理=>快速解绑
        {
          path: "/agent/sendCmd",
          name: "sendCmd",
          component: () =>
            import("../components/agent/device/sendCmd")
        }, //经销商=>设备管理=>命令发送
        {
          path: "/agent/leadSealing",
          name: "leadSealing",
          component: () =>
              import("../components/agent/device/leadSealing.vue")
        }, //经销商=>设备管理=>铅封管理
        {
          path: "/agent/leadSealingEdit",
          name: "leadSealing",
          component: () =>
              import("../components/agent/device/leadSealingEdit.vue")
        }, //经销商=>设备管理=>铅封管理
        {
          path: "/agent/commission",
          name: "commission",
          component: () =>
            import("../components/agent/commission/commission")
        }, //经销商=>分佣管理=>分佣管理
        {
          path: "/agent/withdrawManage",
          name: "withdrawManage",
          component: () =>
            import("../components/agent/withdraw/list")
        },
        {
          path: "/agent/truckDevice/:id",
          name: "truckDevice",
          component: () =>
            import("../components/agent/merchant/truckDevice")
        },// 汽车衡设备

        {
          path: "/agent/merModelList",
          name: "merModelList",
          component: () =>
            import("../components/agent/merchant/merchantModel/merModelList")
        },//经销商=>商户模型管理=>中央模型库
        {
          path: "/agent/merModelCenter",
          name: "merModelCenter",
          component: () =>
            import("../components/agent/merchant/merchantModel/merModelCenter")
        },//经销商=>商户模型管理=>新增模型训练
        {
          path: "/agent/merNewModel",
          name: "merNewModel",
          component: () =>
            import("../components/agent/merchant/merchantModel/merNewModel")
        },//经销商=>商户模型管理=>模型商品管理
        {
          path: "/agent/merGgoodsManage",
          name: "merGoodsManage",
          component: () =>
            import("../components/agent/merchant/merchantModel/merGoodsManage")
        },//经销商=>模型管理=>模型列表
        {
          path: "/agent/modelList",
          name: "modelList",
          component: () =>
            import("../components/agent/modelManage/modelList")
        },//经销商=>模型管理=>中央模型库
        {
          path: "/agent/modelCenter",
          name: "modelCenter",
          component: () =>
            import("../components/agent/modelManage/modelCenter")
        },//经销商=>模型管理=>新增模型训练
        {
          path: "/agent/newModel",
          name: "newModel",
          component: () =>
            import("../components/agent/modelManage/newModel")
        },//经销商=>模型管理=>模型商品管理
        {
          path: "/agent/goodsManage",
          name: "goodsManage",
          component: () =>
            import("../components/agent/modelManage/goodsManage")
        },
        {
          path: "/agent/payAudit",
          name: "payAudit",
          component: () => import("../components/agent/payment/payAudit")
        }, //经销商=>支付管理=>支付申请
        {
          path: "/agent/salesKind",
          name: "salesKind",
          component: () => import("../components/agent/erp/salesKind")
        }, //经销商=>销售参数=>种类
        {
          path: "/agent/salesPLU",
          name: "salesPLU",
          component: () => import("../components/agent/erp/salesPLU")
        }, //经销商=>销售参数=>PLU

      ]
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js